export default __webpack_public_path__ + "images/ac70934a721de761193037a4967d6c1a.svg";